<script lang="ts">
    import { ColourVars, Label, type AvatarSize } from "component-lib";
    import { type Snippet } from "svelte";
    import Close from "svelte-material-icons/Close.svelte";
    import Container from "./Container.svelte";
    import Avatar from "./avatar/Avatar.svelte";

    interface Props {
        children?: Snippet;
        avatarUrl?: string;
        avatarSize?: AvatarSize;
        onRemove?: () => void;
    }
    let { children, onRemove, avatarUrl, avatarSize = "sm" }: Props = $props();
</script>

<Container
    supplementalClass={"user_chip"}
    mainAxisAlignment={"spaceBetween"}
    crossAxisAlignment={"center"}
    width={"hug"}
    gap={"sm"}
    padding={["zero", "md", "zero", "zero"]}
    borderColour={ColourVars.secondary}
    borderRadius={"circle"}
    borderWidth={"thick"}
    onClick={onRemove}>
    {#if avatarUrl}
        <Avatar size={avatarSize} url={avatarUrl}></Avatar>
    {/if}
    <Label colour={"secondaryAccent"} width={"hug"}>
        {@render children?.()}
    </Label>
    {#if onRemove}
        <span class="icon">
            <Close color={ColourVars.secondaryAccent} />
        </span>
    {/if}
</Container>

<style lang="scss">
    :global(.user_chip .icon svg) {
        width: 1rem;
        height: 1rem;
    }
    .icon {
        display: flex;
    }
</style>
